import store from '../store/'

export default {
  install (Vue) {
    Vue.prototype.hasPermission = permission => {
      let permissions = store.state.permissions

      if (Array.isArray(permission)) {
        for (let p of permission) {
          if (permissions.indexOf(p) >= 0) {
            return true
          }
        }
      } else {
        if (permissions.indexOf(permission) >= 0) {
          return true
        }
      }
      // 如果没有权限就返回false
      return false
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/hasPermission.js